module.exports = __webpack_public_path__ + "img/reward_7.0a57993f.png";